module.exports = __webpack_public_path__ + "images/category_lp/watch/assessment_achievements/3@2x_cb045ef6e5ccc6467e9615e0481890ce.png";